import React, { useState, useEffect } from "react";
import "./ComingSoonPage.css";
import logo from '../assets/images/new-header-logo.png';

function ComingSoonPage() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    // Fixed target date: August 1st, 2025 at 10:00 AM (local time)
    const targetDate = new Date(2025, 7, 1, 10, 0, 0); // Note: month is 0-indexed, so 7 = August

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="app">
      <div className="background">
        <div className="overlay"></div>
      </div>

      <div className="content">
        <div className="brand">
          <div className="logo">
            <img src={logo} width={280} />
          </div>
          {/* <h1>
            Art<span className="highlight">Boxy</span>
          </h1> */}
        </div>

        <div className="message-box">
          <h2>We're Getting a Fresh New Look!</h2>
          <p>
            We're currently migrating our data and revamping our website to
            bring you an even better experience. We'll be back online soon with
            exciting new features and improvements.
          </p>

          <div className="timer">
            {["days", "hours", "minutes", "seconds"].map((unit) => (
              <div className="time-unit" key={unit}>
                <div className="number">
                  {String(timeLeft[unit]).padStart(2, "0")}
                </div>
                <div className="label">
                  {unit.charAt(0).toUpperCase() + unit.slice(1)}
                </div>
              </div>
            ))}
          </div>

          <div className="expected">⏰ Expected return: 2 days</div>
        </div>

        <div className="contact-box">
          <h3>Need Assistance?</h3>
          <div className="contact-info">
            <div>📧 support@artboxy.com</div>
          </div>
          <p className="note">
            We apologize for any inconvenience and appreciate your patience
            during this upgrade.
          </p>
        </div>

        <div className="footer">© 2025 ArtBoxy. All rights reserved.</div>
      </div>
    </div>
  );
}

export default ComingSoonPage;
